// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QlL2u","pulseLoader":"styles_pulseLoader__QQVSs","loaderPagination":"styles_loaderPagination__-LGDg"};